import script from "./permission-request.vue?vue&type=script&lang=ts&setup=true"
export * from "./permission-request.vue?vue&type=script&lang=ts&setup=true"

import "./permission-request.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__